/* Native Shopify predictive search, with the approved React dialog composition. */
(function () {
  'use strict';
  var current = null, request = 0, abort, timer;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var base = function () { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; };
  function cancelRequest() { clearTimeout(timer); if (abort) abort.abort(); request++; }
  function motion(state, opening, immediate) {
    var version = ++state.version;
    var panel = state.box.querySelector('[data-search-panel]');
    var backdrop = state.box.querySelector('[data-search-backdrop]');
    var from = state.box.hidden ? {opacity: 0, transform: 'translateY(12px)'} : {opacity: getComputedStyle(panel).opacity, transform: getComputedStyle(panel).transform};
    var shade = state.box.hidden ? 0 : getComputedStyle(backdrop).opacity;
    state.animations.forEach(function (animation) { animation.cancel(); });
    state.animations = [];
    state.box.hidden = false;
    state.box.inert = !opening;
    state.box.dataset.searchState = opening ? 'opening' : 'closing';
    function done() {
      if (version !== state.version) return;
      state.animations.forEach(function (animation) { animation.cancel(); });
      state.animations = [];
      state.box.dataset.searchState = opening ? 'open' : 'closed';
      if (!opening) {
        state.box.hidden = true;
        window.AinazOverlay && AinazOverlay.close(state.box);
        if (current === state) current = null;
      }
    }
    if (immediate || reduce.matches || document.body.dataset.animations === 'false' || !panel.animate) return done();
    state.animations = [
      panel.animate([from, {opacity: opening ? 1 : 0, transform: opening ? 'translateY(0)' : 'translateY(8px)'}], {duration: opening ? 220 : 180, easing: opening ? 'cubic-bezier(.22,1,.36,1)' : 'ease-in', fill: 'both'}),
      backdrop.animate([{opacity: shade}, {opacity: opening ? 1 : 0}], {duration: 180, easing: 'ease', fill: 'both'})
    ];
    Promise.all(state.animations.map(function (animation) { return animation.finished; })).then(done).catch(function () {});
  }
  function close(options) {
    if (!current) return;
    var state = current;
    state.open = false;
    cancelRequest();
    state.box.querySelector('[data-predictive-results]').removeAttribute('aria-busy');
    if (state.trigger) state.trigger.setAttribute('aria-expanded', 'false');
    motion(state, false, options && options.immediate);
  }
  function open(box, trigger) {
    if (current && current.box !== box) close({immediate: true});
    var state = current || {box: box, trigger: trigger, version: 0, animations: []};
    state.open = true;
    state.trigger = trigger;
    current = state;
    trigger.setAttribute('aria-expanded', 'true');
    motion(state, true);
    window.AinazOverlay && AinazOverlay.open(box, close, trigger);
    box.querySelector('[data-predictive-input]').focus({preventScroll: true});
    var input = box.querySelector('[data-predictive-input]');
    if (input.value.trim() && box.dataset.resultQuery !== input.value.trim()) search(input);
  }
  function initial(box) {
    if (box._initialSearch) return box._initialSearch;
    var results = box.querySelector('[data-predictive-results]');
    box._initialSearch = {html: results.innerHTML, count: Number(results.dataset.resultCount) || 0};
    return box._initialSearch;
  }
  function search(input) {
    var box = input.closest('[data-predictive-search]');
    var results = box.querySelector('[data-predictive-results]');
    var status = box.querySelector('[data-search-status]');
    var all = box.querySelector('[data-search-all]');
    var original = initial(box), query = input.value.trim();
    cancelRequest();
    var version = request;
    all.href = query ? base() + 'search?q=' + encodeURIComponent(query) + '&type=product&options[prefix]=last' : base() + 'collections/all';
    all.firstChild.textContent = query ? 'View all results ' : 'Explore all jewelry';
    if (!query) {
      results.innerHTML = original.html;
      results.removeAttribute('aria-busy');
      status.textContent = original.count + ' pieces to explore';
      box.dataset.resultQuery = '';
      return;
    }
    results.replaceChildren();
    results.setAttribute('aria-busy', 'true');
    status.textContent = 'Searching…';
    timer = setTimeout(async function () {
      abort = new AbortController();
      try {
        var url = new URL(box.dataset.searchEndpoint || base() + 'search/suggest', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '8');
        url.searchParams.set('section_id', 'predictive-search');
        var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        var response = await fetch(url.toString(), {signal: abort.signal, credentials: 'same-origin'});
        if (!response.ok) throw Error('Search unavailable');
        var html = new DOMParser().parseFromString(await response.text(), 'text/html');
        var fragment = html.querySelector('[data-search-response]');
        if (!fragment) throw Error('Search unavailable');
        if (version !== request || !current || current.box !== box || !current.open) return;
        results.replaceChildren(document.importNode(fragment, true));
        var count = Number(fragment.dataset.resultCount) || 0;
        status.textContent = count ? count + (count === 1 ? ' piece found' : ' pieces found') : 'No pieces found';
        box.dataset.resultQuery = query;
      } catch (error) {
        if (error.name !== 'AbortError' && version === request && current && current.open) {
          results.replaceChildren();
          status.textContent = 'Suggestions are unavailable. Use View all results to keep searching.';
          delete box.dataset.resultQuery;
        }
      } finally {
        if (version === request) results.removeAttribute('aria-busy');
      }
    }, 200);
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-search-toggle]');
    if (trigger) {
      event.preventDefault();
      var box = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!box) return;
      initial(box);
      if (current && current.box === box && current.open) close(); else open(box, trigger);
    } else if (event.target.closest('[data-search-close],[data-search-backdrop]')) close();
  });
  document.addEventListener('input', function (event) { if (event.target.matches('[data-predictive-input]')) search(event.target); });
  document.addEventListener('keydown', function (event) {
    if (!current || !current.open) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    var links = Array.from(current.box.querySelectorAll('.ainaz-search-result a'));
    if (!links.length) return;
    var index = links.indexOf(document.activeElement);
    if (document.activeElement !== current.box.querySelector('input[type=search]') && index === -1) return;
    event.preventDefault();
    links[index === -1 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
  });
  document.addEventListener('shopify:section:unload', function (event) { if (current && event.target.contains(current.box)) close({immediate: true}); });
  reduce.addEventListener && reduce.addEventListener('change', function () { if (current && reduce.matches) motion(current, current.open, true); });
})();
